<template>
  <div>
    <el-drawer
      title="工单记录"
      :visible.sync="drawer"
      size="600px"
      destroy-on-close
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="巡检记录" name="0"> </el-tab-pane>
        <el-tab-pane label="保养记录" name="1"></el-tab-pane>
        <el-tab-pane label="自检维修记录" name="2"></el-tab-pane>
        <el-tab-pane label="外委维修记录" name="3"></el-tab-pane>
      </el-tabs>
      <div class="content">
        <DeviceInspection
          ref="DeviceInspection"
          :workOrderType="activeName"
          :deviceItemId="row.Id"
          @openView="openView"
        ></DeviceInspection>
      </div>

      <div class="footer">
        <el-button @click="drawer = false">取消</el-button>
      </div>
    </el-drawer>
    <ViewForm ref="ViewForm"></ViewForm>
  </div>
</template>
<script>
import DeviceInspection from '../DeviceInspection.vue'
import ViewForm from '@/views/Operation/OperationWorkOrder/ViewForm.vue'
export default {
  data() {
    return {
      drawer: false,
      row: {},
      activeName: '',
    }
  },
  props: {},
  components: { DeviceInspection, ViewForm },
  methods: {
    openView(item) {
      console.log('222222222')
      this.$refs.ViewForm.openForm('查看工单', item, true)
    },

    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.row = row
      this.activeName = '0'
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  padding: 20px;
  margin: 0;
}
::v-deep .el-drawer__body {
  padding: 0px 10px;
}
::v-deep .el-tabs {
  .el-tabs__header {
    margin: 0;
  }
}
.content {
  height: calc(100% - 80px);
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
</style>
